var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4365 24.2109H19.7908V24.843H20.4365V24.2109Z",
    fill: "#FFD900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2702 24.2109H14.6245V24.843H15.2702V24.2109Z",
    fill: "#F8AF4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 24.2109H12.0413V24.843H12.6875V24.2109Z",
    fill: "#FFD900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4577 17.2637H8.8125V17.8947H9.4577V17.2637Z",
    fill: "#FFD900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87424 14.7368H6.22852V15.3689H6.87424V14.7368Z",
    fill: "#FFE195"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2702 13.4746H14.6245V14.1046H15.2702V13.4746Z",
    fill: "#FDF39D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0412 13.4746H11.3955V14.1046H12.0412V13.4746Z",
    fill: "#FDF39D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.916 12.2104H15.2703V12.8425H15.916V12.2104Z",
    fill: "#FDF39D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 12.2104H12.0413V12.8425H12.6875V12.2104Z",
    fill: "#FFD900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16571 16.0002H8.81248H9.45768H10.1034H10.7491H11.3954H12.0411H12.6873V15.3692H13.3325V14.7372H13.9788H14.6245V14.1046V13.4747H15.2702V12.8426V12.2106H15.9159V11.579V10.9475H16.5617V10.316V9.68447V9.05295V8.4209H15.9159H15.2702V9.05295H14.6245V9.68447H13.9788V10.316H13.3325V10.9475V11.579H12.6873V12.2106V12.8426V13.4747V14.1046H12.0411H11.3954V13.4747H10.7491H10.1034H9.45768H8.81248H8.16571V14.1046H7.51999H6.87427V14.7372V15.3692V16.0002H7.51999H8.16571Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2702 8.4209H14.6245V9.05295H15.2702V8.4209Z",
    fill: "#FDF39D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4988 24.2109V24.843H19.145H19.7907V24.2109H19.145H18.4988Z",
    fill: "#FDC301"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3743 24.2106V24.8427V25.4742V26.1052H23.02V25.4742V24.8427V24.2106V23.5791H22.3743V24.2106Z",
    fill: "#FDC301"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4365 23.5791H19.7908V24.2106H20.4365V23.5791Z",
    fill: "#FDC301"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2702 22.9473H14.6245V23.5793H15.2702V22.9473Z",
    fill: "#FDC301"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 23.5793V24.2108V24.8429V25.4744V26.1054V26.7369H9.4577V26.1054V25.4744V24.8429V24.2108V23.5793V22.9473H8.8125V23.5793Z",
    fill: "#FDC301"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7285 19.7896H21.0828V20.4211H21.7285V19.7896Z",
    fill: "#FDC301"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.104 19.7896H9.45776V20.4211H10.104V19.7896Z",
    fill: "#FDC301"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4365 15.3691H19.7908V16.0001H20.4365V15.3691Z",
    fill: "#FDC301"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6035 14.7368H24.9578V15.3689H25.6035V14.7368Z",
    fill: "#FDC301"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7285 14.7368H21.0828V15.3689H21.7285V14.7368Z",
    fill: "#FDC301"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.02 14.1045H22.3743V14.7365H23.02V14.1045Z",
    fill: "#FDC301"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9578 12.8423V13.4743V14.1043H25.6035V13.4743V12.8423H24.9578Z",
    fill: "#FDC301"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87424 12.8423H6.22852V13.4749H6.87424V12.8423Z",
    fill: "#FDC301"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4365 12.2104H19.7907H19.145V12.8425H19.7907H20.4365H21.0827H21.7284V12.2104H21.0827H20.4365Z",
    fill: "#FDC301"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7492 12.2104H10.1035V12.8425H10.7492H11.3955H12.0412V12.2104H11.3955H10.7492Z",
    fill: "#FDC301"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9788 9.68408H13.3325V10.3156H13.9788V9.68408Z",
    fill: "#FDC301"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.208 8.42055V9.0526V9.68412H17.8537V9.0526V8.42055V7.78955H17.208V8.42055Z",
    fill: "#FDC301"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2702 7.1582H14.6245V7.78973H15.2702V7.1582Z",
    fill: "#FDC301"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7285 18.5256V19.1581H21.0828V19.7897H21.7285V20.4212V21.0527V21.6848V22.3158V22.9473V23.5793V24.2109V24.8429H21.0828H20.4365V25.4744H21.0828H21.7285V26.1054H22.3742V25.4744V24.8429V24.2109V23.5793V22.9473V22.3158V21.6848V21.0527V20.4212V19.7897V19.1581V18.5256V17.894H21.7285V18.5256Z",
    fill: "#FDEB19"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.02 17.2637H22.3743V17.8947H23.02V17.2637Z",
    fill: "#FDEB19"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6657 16.6309H23.02V17.2629H23.6657V16.6309Z",
    fill: "#FDEB19"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 16H23.6658V16.6315H24.312V16Z",
    fill: "#FDEB19"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9577 15.3691H24.312V16.0001H24.9577V15.3691Z",
    fill: "#FDEB19"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.249 13.4746H25.6033V14.1046V14.7371H26.249V14.1046H26.8952V13.4746H26.249Z",
    fill: "#FDEB19"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16586 14.1043V13.4743H8.81263H9.45783H10.1035H10.7493H11.3955H12.0412V14.1043H12.6875V13.4743V12.8423H12.0412H11.3955H10.7493H10.1035H9.45783H8.81263H8.16586H7.52014H6.87442V13.4743H6.2287H5.58298H4.93726V14.1043H5.58298V14.7369H6.2287H6.87442V14.1043H7.52014H8.16586Z",
    fill: "#FDEB19"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6657 12.8423H23.02H22.3742H21.7285H21.0828H20.4365H19.7908H19.1451V12.2103V11.5788H18.4989V10.9472V10.3157H17.8537V9.6842H17.2079V9.05268V8.42063V7.78963V7.1581H16.5617V6.52605V5.89453H15.916H15.2702V6.52605V7.1581V7.78963H14.6245V8.42063H15.2702H15.916H16.5617V9.05268V9.6842V10.3157V10.9472H15.916V11.5788V12.2103V12.8423H15.2702V13.4744V14.1043H14.6245V14.7369H13.9788H13.3326V15.369H12.6874V16H12.0411H11.3954H10.7492H10.1034H9.45771H8.81251H8.16574H7.52002V16.631H8.16574V17.2635H8.81251H9.45771V17.894V18.5255H10.1034V19.1581V19.7896V20.4212H9.45771V21.0527V21.6847V22.3157V22.9472V23.5793V24.2108V24.8429V25.4744V26.1054H10.1034V25.4744H10.7492H11.3954V24.8429H12.0411V24.2108H12.6874H13.3326H13.9788V23.5793H14.6245V22.9472H15.2702H15.916H16.5617H17.2079V23.5793H17.8537V24.2108H18.4989H19.1451H19.7908V23.5793V22.9472V22.3157H19.1451V21.6847V21.0527V20.4212H18.4989V19.7896V19.1581V18.5255H17.8537V17.894V17.2635H18.4989H19.1451V16.631H19.7908V16V15.369H20.4365H21.0828V14.7369H21.7285H22.3742V14.1043H23.02H23.6657V13.4744H24.3119H24.9576V12.8423H24.3119H23.6657Z",
    fill: "#FDEB19"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 10.9473H12.6875V11.5788H13.3327V10.9473Z",
    fill: "#FDEB19"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6245 9.05273H13.9788V9.68426H14.6245V9.05273Z",
    fill: "#FDEB19"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6658 16.6312V16.0002H24.312V15.3692H24.9577V14.7371H25.6035V14.1046H24.9577V13.4746H24.312H23.6658V14.1046H23.0201V14.7371H22.3743H21.7286V15.3692H21.0829H20.4366V16.0002H19.7909V16.6312H19.1452V17.2638H18.499H17.8538V17.8942V18.5257H18.499V19.1583V19.7898V20.4214H19.1452V21.0529V21.6849V22.3159H19.7909V22.9475V23.5795H20.4366V24.211V24.8431H21.0829H21.7286V24.211V23.5795V22.9475V22.3159V21.6849V21.0529V20.4214H21.0829V19.7898V19.1583H21.7286V18.5257V17.8942H22.3743V17.2638H23.0201V16.6312H23.6658Z",
    fill: "#F39205"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1863 12.2103H22.3737V11.5788H20.436V10.3158H19.7903V9.68424H19.1446V8.42119H18.4984V7.15814H17.8526V5.26357H17.2069V4.63152H16.5612V4H15.2698V4.63152H14.624V6.52609H13.9783V7.15814H13.3321V8.42119H12.6869V9.68424H12.0406V10.3158H11.3949V11.5788H9.45721V12.2103H3V14.1049H3.64572V14.737H4.29144V15.369H4.93716V16H5.58288V16.6315H6.22861V17.2636H6.87433V17.8946H7.52005V18.5261H8.16577V19.1587H8.81202V22.3163H8.16577V25.475H7.52005V28.0011H8.81202V27.3695H10.7492V26.738H12.0406V26.1065H12.6869V25.4755H13.9783V24.844H14.624V24.2119H15.2698V24.844H17.8526V25.4755H19.1441V26.1065H19.7898V26.738H21.0818V27.3695H23.0189V28.0011H24.3109V26.1065H23.6646V22.9483H23.0189V18.5266H23.6646V17.8951H25.6023V16.632H26.2475V16.0005H26.8938V15.3695H27.5395V14.7375H28.1852V14.1054H28.8309V12.2109H28.1852L28.1863 12.2103ZM23.02 17.2636V17.8946H22.3743V23.5793H23.02V26.1054H21.7285V25.4744H20.4366V24.8429H18.4994V24.2109H17.8537V23.5793H17.208V22.9473H15.2708V23.5793H13.9794V24.2109H12.6879V24.8429H11.396V25.4744H10.1045V26.1054H9.45826V26.737H8.81307V22.9473H9.45826V19.7897H10.1045V18.5256H9.45826V17.894H8.81307V17.263H8.16682V16.631H7.5211V15.9995H6.87538V15.3685H6.22966V14.7364H5.58394V14.1044H4.93821V13.4744H6.22966V12.8419H10.105V12.2098H12.6884V10.9468H13.3336V9.68371H13.9799V9.05219H14.6256V7.15762H15.2713V5.89404H16.5628V7.15762H17.2085V7.78914H17.8542V10.3152H18.4999V11.5783H19.1462V12.2098H21.7296V12.8419H25.605V13.4744H26.8964V14.1044H26.2502V14.7364H25.605V15.3685H24.9592V15.9995H24.3135V16.631H23.6673V17.263H23.0216L23.02 17.2636Z",
    fill: "#F39205"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0785 19.74V14.66H14.8985L14.2385 17.06H12.9785V16.94L13.8185 14H16.3985V19.74H18.1385V21H13.0985V19.74H15.0785Z",
    fill: "#130900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank1);
export default __webpack_public_path__ + "static/media/Rank1.d5f913f3c42a099ddf0173e2f3a5c1ab.svg";
export { ForwardRef as ReactComponent };